import destinationMetricSchemaUIStore from './destinationMetricSchemaUIStore.js';
import destinationMetricSchemaDataStore from './destinationMetricSchemaDataStore.js';

export default {
  modules: {
    ui: destinationMetricSchemaUIStore,
    data: destinationMetricSchemaDataStore,
  },
};
